/// カスタムポップアップ
(function(ns, BS) {
	"use strict";

	var GM, iconHeight = 60, prototype;

	function createShopInfoWindow() {
		if (!GM) {
			GM = google.maps;
			ShopInfoWindow.prototype = $.extend(new GM.OverlayView, prototype);
		}
		return new ShopInfoWindow;
	}

	function ShopInfoWindow() {
		var me = this, args = arguments;

		me.visible = false;

		me.map = null;

		me.winE = null;
		me.winWidth = 0;
		me.winHeight = 0;

		me.init.apply(me, args);
	}

	ShopInfoWindow.create = createShopInfoWindow;

	prototype = {

		init: function() {
			var me = this;

			me.winE = $("<div class='shop-info-window'>");
			me.stopEvents_();
		},

		/// オーバーレイ上でイベントが伝播しないようにして、地図が操作されるのを防ぐ
		stopEvents_: function() {
			var events = [
				"click", "dblclick", "rightclick"
				, "mousedown", "mouseup", "mousemove", "mouseover", "mouseout"
				, "dragstart", "dragend", "contextmenu"
				, "touchstart", "touchmove", "touchend"
			]
			, el = this.winE[0]
			, i = 0
			, event
			;
			while ((event = events[i++])) {
				GM.event.addDomListener(el, event, cancelEvent);
			}

			function cancelEvent(evt) {
				evt.cancelBubble = true; // IE
				if (evt.stopPropagation) {
					evt.stopPropagation();
				}
				if (evt.type === "click" && evt.target && evt.target.getAttribute("data-shop-id")) {
					var shopOpenEvent = document.createEvent("Event");
					shopOpenEvent.initEvent("shopTrigger", true, true);
					shopOpenEvent.shopId = parseInt(evt.target.getAttribute("data-shop-id"), 10);
					window.dispatchEvent(shopOpenEvent);
				}
			}
		},

		setShop: function(shop) {
			this.winE.empty().append(
				BS.Template.createDOM(
					'<div class="search-shop-detail-content">' +
					'<h4 class="shop-info-window-title">' +
					'{% name %}' +
					(shop.is_perm_closed ?
						' <span class="fi fi-disabled">閉店</span>' :
						(shop.is_closed ?
							' <span class="fi fi-disabled">休業中</span>' :
							''
						)
					) +
					'</h4>' +
					(!shop.is_perm_closed && !shop.is_closed ? (
						'<ul class="feature-list">' +
						'<li><span class="fi" aria-label="営業時間">営</span>&nbsp;{% open_time %}</li>' +
						'<li><span class="fi" aria-label="休業日">休</span>&nbsp;{% closed %}</li>' +
						(shop.num_parking > 0 ?
							'<li><span class="fi" aria-label="駐車場">駐</span>&nbsp;あり</li>' :
							''
						)
					) : '') +
					'</ul>' +
					'<div class="action"><button type="button" data-shop-id="{% id %}" class="btn btn-p btn-sm">詳細</button></div>' +
					'</div>',
					shop
				)
			);
		},

		open: function(map, marker, shop) {
			var me = this;

			me.map = map;
			me.setMap(map); // OverlayView.setMap()
			me.setShop(shop);

			me.marker = marker;
			me.draw();

			if (me.visible) {
				// NOTE: 新規に開くときは onAdd() が呼ばれるまで getProjection() が null を返す。
				// そのため新規の場合は onAdd() で adjustMapPosition() を呼び、
				// すでに開いている場合はここで adjustMapPosition() を呼ぶ。
				me.adjustMapPosition();
			}

			me.visible = true;
		},

		close: function() {
			var me = this;
			me.setMap(null); // OverlayView.setMap()
			me.visible = false;
		},

		isVisible: function() {
			return this.visible;
		},

		addEventListener: function(type, func, useCapture) {
			this.winE[0].addEventListener(type, func, useCapture);
		},

		/// google.maps.Map からコールバック
		onAdd: function() {
			var me = this, panes;

			// レイヤーにこのdivを張り込む
			panes = me.getPanes();
			panes.floatPane.appendChild(me.winE[0]);

			// NOTE: getProjection() はこの処理以降に有効になるためタイマーを設定する
			setTimeout(function() {
				me.adjustMapPosition();
			});
		},

		onRemove: function() {
			var me = this;
			if (me.winE) {
				me.winE.remove();
			}
		},

		/// google.maps.Map からコールバック
		draw: function() {
			var me = this, projection, pos;

			if (!me.marker) {
				return;
			}

			// 経度緯度から画面座標系に変換
			projection = me.getProjection();
			if (!projection) {
				return;
			}

			pos = projection.fromLatLngToDivPixel(me.marker.getPosition());
			if (!pos) {
				return;
			}

			me.winWidth = me.winE.outerWidth();
			me.winHeight = me.winE.outerHeight();

			me.winE.css({
				left: (pos.x - me.winWidth/2) + "px",
				top: (pos.y - (me.winHeight + iconHeight)) + "px"
			});
		},

		// 情報ウィンドウが画面内に入るように地図を移動する
		adjustMapPosition: function() {
			var me = this, padding, map, mapE, projection, pos, mapWidth, mapHeight, winX, winY, panX, panY;

			if (!me.visible) {
				return;
			}

			padding = 10;
			panX = 0;
			panY = 0;

			map = me.map;
			if (!map) {
				return;
			}

			projection = me.getProjection();
			if (!projection) {
				return;
			}

			pos = projection.fromLatLngToContainerPixel(me.marker.getPosition());
			if (!pos) {
				return;
			}

			mapE = map.getDiv();
			mapWidth = $(mapE).width();
			mapHeight = $(mapE).height();

			winX = pos.x - me.winWidth/2;
			winY = pos.y - (me.winHeight + iconHeight);

			if (winX - padding < 0) {
				panX = winX - padding;
			} else if (winX + me.winWidth + padding > mapWidth) {
				panX = winX + me.winWidth + padding - mapWidth;
			}

			if (winY - padding < 0) {
				panY = winY - padding;
			} else if (winY + me.winHeight + padding > mapHeight) {
				panY = winY + me.winHeight + padding - mapHeight;
			}

			var now = Date.now();
			if (me.t0 && now - me.t0 < 100) {
				throw new Error("呼びすぎ");
			}
			me.t0 = now;
			// console.log("adjustMapPosition: panBy(%d, %d)", panX, panY);

			if (panX !== 0 || panY !== 0) {
				map.panBy(panX, panY);
			}
		}

	};

	ns.ShopInfoWindow = ShopInfoWindow;

})(window, BS);
